import { Badge, Button, Flex, Heading, IconButton, Portal, Text } from '@radix-ui/themes';
import { motion } from 'framer-motion';
import { TbChevronRight, TbSparkles, TbX } from 'react-icons/tb';
import { RadixThemeProvider } from '../../lib/radix/RadixThemeProvider';
import Styles from './css/releases-pop-up.module.scss';
import { releaseItems } from './releaseItems';
import { useStore } from '@nanostores/react';
import { interfaceStore } from '~/stores/interface';

export function ReleasesPopUp({
  handleUserDecision,
  userBehindByMultiple,
}: {
  handleUserDecision: (open: boolean) => void;
  userBehindByMultiple: boolean;
}) {
  const latestRelease = releaseItems[releaseItems.length - 1];
  const appearanceMode = useStore(interfaceStore.appearanceMode);

  const handleClose = () => {
    handleUserDecision(false);
  };

  const handleViewAllUpdates = () => {
    handleUserDecision(true);
  };

  return (
    <Portal>
      <RadixThemeProvider appearance={appearanceMode}>
        <motion.div
          className={Styles.ReleasesPopUp}
          initial={{ x: 330, opacity: 0 }}
          animate={{
            x: 0,
            opacity: 1,
            transition: {
              type: 'spring',
              stiffness: 160,
              damping: 18,
              mass: 1,
              bounce: 0.1,
              duration: 0.1,
              delay: 2,
            },
          }}
          exit={{
            scale: 0.95,
            y: 10,
            opacity: 0,
            transition: {
              type: 'spring',
              stiffness: 180,
              damping: 18,
              mass: 1,
              bounce: 1,
              duration: 0.1,
            },
          }}
        >
          <Flex direction="column" gap="3" height="100%">
            <Flex align="center" gap="2">
              <Flex justify="center" align="center" className={Styles.ReleasesPopUpSparkles}>
                <TbSparkles fontSize="2rem" color="var(--cyan-12" />
              </Flex>
              <Badge radius="full" size="1" highContrast>
                New Release{userBehindByMultiple ? 's' : ''}
              </Badge>
            </Flex>

            <Flex flexGrow="1" width="100%">
              {latestRelease && (
                <Flex key={latestRelease.id} direction="column" gap="2" width="100%">
                  <Heading size="2">{latestRelease.name}</Heading>
                  <Text size="1" className={Styles.ReleasesPopUpDescription}>
                    {latestRelease.description}
                  </Text>
                </Flex>
              )}
            </Flex>

            <Flex justify="center" width="100%" className={Styles.ReleasesPopUpButton}>
              <Button size="2" variant="outline" onClick={handleViewAllUpdates}>
                <Text size="2">View All Releases</Text>
                <TbChevronRight fontSize="1.6rem" />
              </Button>
            </Flex>
          </Flex>
          <Flex direction="column" gap="2" className={Styles.ReleasesPopUpCloseButton}>
            <IconButton variant="ghost" size="1" color="gray">
              <TbX onClick={handleClose} />
            </IconButton>
          </Flex>
        </motion.div>
      </RadixThemeProvider>
    </Portal>
  );
}
